import React from "react";

const VoiceReviewModal = ({
  user,
  actionType,
  onClose,
  onSubmit,
  reviewNotes,
  setReviewNotes,
  rejectionReason,
  setRejectionReason,
}) => {
  if (!user) return null;

  return (
    <div className="fixed  inset-0 z-50 flex items-center justify-center bg-[var(--black)] modal-backdrop p-4">
      <div className="bg-white border border-gray-200 rounded-xl shadow-lg w-full max-w-md p-6 relative max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="px-6 py-4 border-b border-gray-200 flex border justify-between items-center">
          <h2 className="text-xl font-semibold text-gray-800">
            Review Voice File
          </h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 text-2xl"
          >
            &times;
          </button>
        </div>

        {/* Body */}
        <div className="p-6 space-y-4">
          {/* User Info */}
          <div className="flex items-center gap-4">
            <div className="bg-pink-500 text-white text-lg font-bold w-12 h-12 flex items-center justify-center rounded-full">
              {user.fullName ? user.fullName.charAt(0).toUpperCase() : "U"}
            </div>
            <div>
              <h3 className="font-semibold text-gray-800">{user.fullName}</h3>
              <p className="text-sm text-gray-500">{user.phoneNumber}</p>
              <p className="text-sm text-gray-400">
                Gender: {user.gender || "female"}
              </p>
              <p className="text-sm text-gray-400">
                Location: {user.state || "Madhya Pradesh"}
              </p>
            </div>
          </div>

          {/* Voice Section */}
          {user.voice && (
            <div>
              <p className="text-gray-700 font-medium mb-2">🎵 Voice Recording:</p>
              <audio
                controls
                className="w-full rounded-lg"
                src={user.voice}
              />
            </div>
          )}

          {/* Review Notes */}
          <div>
            <label className="block text-gray-700 font-medium mb-1">
              Review Notes (optional)
            </label>
            <textarea
              value={reviewNotes}
              onChange={(e) => setReviewNotes(e.target.value)}
              className="w-full border rounded-lg p-2 text-sm focus:ring-2 focus:ring-pink-400 outline-none"
              rows={3}
              placeholder="Add any notes about this voice file review..."
            />
          </div>

          {/* Rejection Reason */}
          {actionType === "reject" && (
            <div>
              <label className="block text-gray-700 font-medium mb-1">
                Rejection Reason <span className="text-red-500">*</span>
              </label>

              <textarea
                value={rejectionReason}
                onChange={(e) => setRejectionReason(e.target.value)}
                className={`w-full border rounded-lg p-2 text-sm focus:ring-2 outline-none ${!rejectionReason.trim()
                    ? "border-red-400 focus:ring-red-400"
                    : "border-gray-300 focus:ring-green-400"
                  }`}
                rows={3}
                placeholder="Explain why this voice file is being rejected..."
                required
              />

             
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="px-6 py-4 border-t border-gray-200 flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 btn btn-warning rounded-lg border border-gray-200 bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium"
          >
            Cancel
          </button>
          {actionType === "approve" ? (
            <button
              onClick={() => onSubmit(true)}
              className="px-5 py-2 rounded-lg bg-green-500 hover:bg-green-600 text-white font-medium"
            >
              Approve
            </button>
          ) : (
            <button
              onClick={() => onSubmit(false)}
              className="px-5 py-2 rounded-lg bg-red-500 hover:bg-red-600 text-white font-medium"
            >
              Reject
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default VoiceReviewModal;
